<div class="work-application-container">
  <h1 class="page-title">{{ pageTitle }}</h1>

  <!-- 表單資料顯示區塊 -->
  <div class="panel showlist-panel mt-4">
    <div class="panel-content">
      <app-showlist
        [formName]="formName"
        [formId]="formId"
       >
      </app-showlist>
    </div>
  </div>
</div>
